import { IFieldRuleConfig } from "@presentation/FormBuilder/Rules/config";
import { ICheckBoxFieldProps } from "../FormCheckboxField";
import { IFormCurrencyFieldProps } from "../FormCurrencyField";
import { ICurrencyFieldConfigurationClient } from "../FormCurrencyField/interface";
import { IFormDateInputProps } from "../FormDateField";
import { IDatepickerFieldConfigurationClient } from "../FormDateField/interface";
import { IDateTimepickerFieldConfigurationClient } from "../FormDateTimePickerField/interface";
import { IDropdownFieldConfigurationClient } from "../FormDropdownField/interface";
import { IFormFileUploadFieldProps } from "../FormFileUploadField";
import { IFileUploadFieldConfigurationClient } from "../FormFileUploadField/interface";
import { IFormLinearScaleProps } from "../FormLinearScaleField";
import { ILinearScalingFieldConfigurationClient } from "../FormLinearScaleField/interface";
import { IFormMultipleChoiceProps } from "../FormMultipleChoicesField";
import { IMultiChoiceFieldConfigurationClient } from "../FormMultipleChoicesField/interface";
import { IRatingFieldConfigurationClient } from "../FormRatingField/interface";
import { IFormRatingFieldProps } from "../FormRatingField/index";
import { IFormTextAreaFieldProps } from "../FormTextAreaField";
import { ITextAreaFieldConfigurationClient } from "../FormTextAreaField/interface";
import { IFormTextInputFieldProps } from "../FormTextInputField";
import { ITextInputFieldConfigurationClient } from "../FormTextInputField/interface";
import { IFormNumberInputFieldProps } from "../FormNumberInputField";
import { INumberInputFieldConfigurationClient } from "../FormNumberInputField/interface";
import { IFormTimePickerFieldProps } from "../FormTimePickerField";
import { ITimepickerFieldConfigurationClient } from "../FormTimePickerField/interface";
import { ISequenceFieldConfigurationClient } from "../FormSequenceField/interface";
import { IButtonFieldConfigurationClient } from "../FormButtonField/interface";
import { IFormButtonFieldProps } from "../FormButtonField"
import { IFormSequenceFieldProps } from "../FormSequenceField";
import { IFormSignatureFieldProps } from "../FormSignatureComponent";
import { ISignatureComponentConfigurationClient } from "../FormSignatureComponent/interface";
import { IDoublePanelFieldConfigurationClient } from "../FormDoublePanelField/interface";
import { IFormDoublePanelFieldProps } from '../FormDoublePanelField';
import { IBannerFieldConfigurationClient } from "../FormBannerField/interface";
import { IFormBannerFieldProps } from "../FormBannerField";

import {
  Address,
  Calculation,
  CheckBox,
  Currency,
  Dates,
  Datetime,
  Decimal,
  DecisionBox,
  Dropdown,
  blankbox,
  Fileupload,
  Mail,
  MultiChoice,
  Multiline,
  Name,
  Number,
  Payment,
  Phone,
  Rating,
  sectionIcon,
  Singleline,
  Slider,
  Time,
  Website,
  DescriptionField,
  lookupIcon,
  dataGrid,
  geoLocationGroup,
  sequence,
  pincode,
  linkForm,
  button,
  SignatureLogo,
  DoublePanel,
  Banner,
  linkedDropdown,
  recaptcha,
} from "@assets/images";
import { PreDefinedFormFieldTypes } from "@presentation/FormBuilder/FieldConfigs/config";
import { ICalculativeInputFieldConfigurationClient } from "../FormCalculativeInputField/interface";
import { IFormCalculativeInputFieldProps } from "../FormCalculativeInputField";
import { IDescriptionFieldConfigurationClient } from "../DescriptionField/interface";
import { IFormDescriptionFieldProps } from "../DescriptionField";
import { IEmptyFieldProps } from "../EmptyField";
import { IPaymentInputFieldConfigurationClient } from "../FormPaymentInputField/interface";
import { IFormPaymentInputFieldProps } from "../FormPaymentInputField";
import { ISectionFieldConfigurationClient } from "../FormSectionOverviewComponent/utils";
import {
  justifyContentEnum,
  sizeType,
} from "@erelego/design-system/components/atoms/Grid/interface";
import { IFormLookUpFieldProps } from "../FormLookupField";
import { IFormLookUpConfigurationClient } from "../FormLookupField/interface";
import { descriptionType } from "../utils";
import { IFormGeolocationFieldProps } from "../FormGeolocationField";
import { IGeolocationConfigurationClient } from "../FormGeolocationField/interface";
import { ITableFieldConfigurationClient } from "../FormTableField/interface";
import { IPincodeFieldConfigurationClient } from "../FormPincodeField/interface";
import { IPincodeFieldProps } from "../FormPincodeField";
import { IFormYearDropdownFieldConfigurationClient } from "../FormYearsDropdown/interface";
import { IFormTimeSlotProps } from "../FormTimeSlot";
import { ISlotSetting, ITimeOfDayConfig } from "@common/redux/formBuilder/interface";
import { ITimeSlotFieldConfigurationClient } from "../FormTimeSlot/interface";
import { IFormTableFieldProps } from "../FormTableField";
import { IFormLinkedDropdownField } from "../FormLinkedDropdownField";
import { ILinkedDropdownFieldConfigurationClient } from "../FormLinkedDropdownField/interface";
import { IFormCaptchaFieldProps } from "../FormCaptchaField";
import { ICaptchaFieldConfigurationClient } from "../FormCaptchaField/interface";

export interface IBaseFormField {
  localId: string;
  parentFormId?: string;
  formId?: string;
  fieldId?: string;
  isSection?: boolean;
  fieldType?: FormFieldTypes | string;

  ref?: string; // For focusing the field

  formMode?: FormModes | string;
  actualFormMode?: FormModes | string;
  field_db_name?: string;

  title?: string;
  description?: string;
  descriptionImage?: string;

  isRequired?: boolean;
  isDuplicateAllowed?: boolean;
  descriptionType?: descriptionType;
  isPII?: boolean;
  fieldMode?: FieldModes;
  position?: number;

  isFieldFocused?: boolean;
  isEditingField?: boolean;
  isDisabled?: boolean;
  fieldValue?: Partial<IFieldValuesConfiguration & IFieldRule>;
  fields?: string[];
  settings?: IFormFieldSettings;
  // eslint-disable-next-line @typescript-eslint/ban-types
  permission?: {};
  rules?: IFieldRuleConfig[];

  css?: IFormFieldCss;
  grid?: IFormFieldGrid;
  type?: string;
  name?: string;
  element?: string;
  id?: string;
  isVisible?: boolean;
  isFocus?: boolean;
  createdDate?: number;
  updatedDate?: number;
  referenceId?: string;
  isReferenceField?: boolean;
  prefix?: string;
  postfix?: string;
  eyeIcon?: boolean;
  completeEncrypt?: boolean;
  sequenceType?: string;
  hideFromVisiblity?: string;
  generateSequenceByWorkflow?: boolean;
  numericSequenceCount?: number;
  defaultSequenceValue?: number;
  dateRangeEnabled?: boolean;
  isWeekendDisabled?: boolean;
  specificDateSelectionEnabled?: boolean;
  specificDateRangeEnabled?: boolean;
  jsonApiEnabled?: boolean;
  preDisableDateCount?: string;
  postDisableDateCount?: string;
  specificDates?: [];
  specificDateRange?: [];
  dateJsonApiUrl?: string;
  slotDuration?: string;
  slotSetting?: ISlotSetting;
  dateReferralFieldId?: string;
  isPartOfTimeSlot?: string;
  isCurrentDateSelected?: boolean;
  dateInitialValueType?: string;
  isCurrentTimeSelected?: boolean;
  timeInitialValueType?: string;
  isCurrentDateTimeSelected?: boolean;
  dateTimeInitialValueType?: string;
  isPastDateDisabled?: boolean;
  fromFieldId?: any;
  toFieldId?: any;
  fromTimeFieldId?: string;
  toTimeFieldId?: string;
  isRegularTimeFormat?: boolean;
  linkedValues?: string[];
   isRichTextEnable?: boolean;
  captchadropdownOptions?: string;
  isTimeOfDayRequired?: boolean;
  timeOfDayFieldId?: string;
  isMonthDisplayRequired?: boolean;
  monthDisplayFieldId?: string;
  timeOfDayConfig?:ITimeOfDayConfig[];
}

export type IFieldValuesConfiguration = Partial<
  ICurrencyFieldConfigurationClient &
  IFileUploadFieldConfigurationClient &
  ILinearScalingFieldConfigurationClient &
  IDropdownFieldConfigurationClient &
  IMultiChoiceFieldConfigurationClient &
  IDatepickerFieldConfigurationClient &
  ITimepickerFieldConfigurationClient &
  ITextInputFieldConfigurationClient &
  INumberInputFieldConfigurationClient &
  IDateTimepickerFieldConfigurationClient &
  ICalculativeInputFieldConfigurationClient &
  IRatingFieldConfigurationClient &
  IDescriptionFieldConfigurationClient &
  IPaymentInputFieldConfigurationClient &
  ISectionFieldConfigurationClient &
  ITextAreaFieldConfigurationClient &
  IFormLookUpConfigurationClient &
  IGeolocationConfigurationClient &
  ITableFieldConfigurationClient &
  ISequenceFieldConfigurationClient &
  IPincodeFieldConfigurationClient &
  IFormYearDropdownFieldConfigurationClient &
  ITimeSlotFieldConfigurationClient &
  IButtonFieldConfigurationClient &
  IBannerFieldConfigurationClient &
  ITimeSlotFieldConfigurationClient &
  ISignatureComponentConfigurationClient &
  IDoublePanelFieldConfigurationClient &
  ILinkedDropdownFieldConfigurationClient &
  IDoublePanelFieldConfigurationClient &
  ICaptchaFieldConfigurationClient
>;

export interface IFormFieldSettings {
  visibility?: IFormFieldVisibility;
}

export interface IFieldDetails {
  type: string;
  image: string;
}

export interface ISelectField {
  type: string;
  fields: IFieldDetails[];
}

export interface IFormFieldGrid {
  width?: number;
  isNewRow?: boolean;
  selectedGridSize?: sizeType | boolean;
}

export interface IFormFieldCss {
  justify?: string;
}

export interface IFormFieldVisibility {
  isVisible?: boolean;
  isDisabled?: boolean;
}

export interface IFieldRule {
  isUpfrontRule?: boolean; // major rule
  ruleType: string; //ruleType
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  ruleValue?: any;
  ruleErrorValue?: string;
}

export enum FormFirstLayerFieldListTypes {
  NUMBER = "Number",
  DECIMAL = "Decimal",
  DECISION_BOX = "Decision Box",
}

export enum FormSecondLayerFieldListTypes {
  NAME = "Name",
  ADDRESS = "Address",
  PHONE = "Phone",
  EMAIL = "Email",
}

export enum FormThirdLayerFieldListTypes {
  WEBSITE = "Website",
  CALCULATIVE = "CALCULATIVE",
  SECTION = "Section",
  PAGE_BREAK = "Page Break",
  PAYMENT = "Payement",
  GEOLOCATION = "Geolocation",
}

export enum FormFieldTypesNames {
  TEXT_INPUT = "Short Text",
  FORM_LINK = "Form link",
  TEXT_AREA = "Long Text",
  MULTIPLE_CHOICES = "Choices",
  DROPDOWN = "Dropdown",
  DATE_INPUT = "Date",
  TIME_PICKER = "Time",
  LINEAR_SCALING = "Slider",
  FILE_UPLOAD = "File Upload",
  CURRENCY = "Currency",
  RATING = "Rating",
  DESCRIPTION = "Rich Text",
  NUMBER_INPUT = "Number",
  DATE_TIME_PICKER = "Date & Time",
  CHECK_BOX = "Decision Box",
  LOOKUP = "Lookup",
  DECIMAL = "Decimal",
  DECISION_BOX = "Decision Box",
  CALCULATIVE = "Formula",
  PAGE_BREAK = "Page Break",
  PAYMENT = "Payment",
  BLANK_BOX = "Empty space",
  DATA_GRID = "Table (Data Grid)",
  GEOLOCATION = "Geolocation",
  SEQUENCE = "Sequence",
  PIN_CODE = "Pincode",
  YEAR_SELECTOR = "Year Selector",
  TIME_SLOT = "Time Slot",
  BUTTON = "Button",
  SIGNATURE_BOX = "Signature",
  BANNER = "Banner",
  LINKED_DROPDOWN = "Linked Dropdown",
  DOUBLE_PANEL = "Double Panel",
  CAPTCHA = "Captcha"
}
export enum FormFieldTypes {
  TEXT_INPUT = "TEXT_INPUT",
  PIN_CODE = "PIN_CODE",
  TEXT_AREA = "TEXT_AREA",
  MULTIPLE_CHOICES = "MULTIPLE_CHOICES",
  DROPDOWN = "DROPDOWN",
  DATE_INPUT = "DATE_INPUT",
  TIME_PICKER = "TIME_PICKER",
  LINEAR_SCALING = "LINEAR_SCALING",
  FILE_UPLOAD = "FILE_UPLOAD",
  CURRENCY = "CURRENCY",
  RATING = "RATING",
  DATE_TIME_PICKER = "DATE_TIME_PICKER",
  CHECK_BOX = "CHECK_BOX",
  NUMBER_INPUT = "NUMBER_INPUT",
  DECIMAL = "DECIMAL",
  DECISION_BOX = "DECISION_BOX",
  CALCULATIVE = "CALCULATIVE",
  PAGE_BREAK = "PAGE_BREAK",
  PAYMENT = "PAYMENT",
  DESCRIPTION = "DESCRIPTION",
  BLANK_BOX = "BLANK_BOX",
  SECTION = "SECTION",
  LOOKUP = "LOOKUP",
  DATA_GRID = "DATA_GRID",
  GEOLOCATION = "GEOLOCATION",
  SEQUENCE = "SEQUENCE",
  FORM_LINK = "FORM_LINK",
  YEAR_SELECTOR = "YEAR_SELECTOR",
  TIME_SLOT = "TIME_SLOT",
  BUTTON = "BUTTON",
  SIGNATURE_BOX = "SIGNATURE_BOX",
  DOUBLE_PANEL = "DOUBLE_PANEL",
  BANNER = "BANNER",
  LINKED_DROPDOWN = "LINKED_DROPDOWN",
  CAPTCHA = "CAPTCHA"
}

export enum FieldOperations {
  NEW_ROW = "Add New Row",
  ADD_FIELD = "Add Field",
  COPY_FIELD = "Copy Field",
  ADD_SECTION = "Add Section",
  DELETE = "Delete",
  EDIT = "Edit",
}

export enum SelectionTypes {
  SINGLE_SELECTION = "SINGLE_SELECTION",
  MULTIPLE_SELECTION = "MULTIPLE_SELECTION",
}

export enum SelectionTypesNames {
  SINGLE_SELECTION = "Single Selection",
  MULTIPLE_SELECTION = "Multiple Selection",
}

export enum DisplayTypes {
  DROPDOWN = "DROPDOWN",
  TEXT = "TEXT",
}

export enum DisplayTypesNames {
  DROPDOWN = "Dropdown",
  TEXT = "Text",
}

export enum AlignDirectionTypes {
  row = "row",
  column = "column",
}
export enum AlignDirectionTypeNames {
  row = "Row",
  column = "Column",
}

export enum FieldModes {
  view = "VIEW",
  edit = "EDIT",
}

export enum FormModes {
  view = "VIEW",
  edit = "EDIT",
  preview = "PREVIEW",
  responseView = "RESPONSEVIEW",
  viewLock = "VIEWLOCK",
}

export enum SignatureOptionType {
  MANUALLY = "MANUALLY",
  ESIGN = "E-SIGN",
}

export enum SignatureOptionDisplayTypes {
  MANUALLY = "Manual",
  ESIGN = "E-sign",
}

export enum GeoLocationOptionTypes {
  AUTOINPUT = "Auto fetch location",
  USERINPUT = "Allow user to search location"
}

export const FieldsDetails = [
  {
    type: "FirstLayerField",
    fields: [
      {
        type: FormFieldTypesNames.TEXT_INPUT,
        image: Singleline,
      },
      {
        type: FormFieldTypesNames.TEXT_AREA,
        image: Multiline,
      },
      {
        type: FormFirstLayerFieldListTypes.NUMBER,
        image: Number,
      },
      {
        type: FormFirstLayerFieldListTypes.DECIMAL,
        image: Decimal,
      },
      {
        type: FormFieldTypesNames.DROPDOWN,
        image: Dropdown,
      },
      {
        type: FormFieldTypesNames.MULTIPLE_CHOICES,
        image: MultiChoice,
      },
      {
        type: FormFirstLayerFieldListTypes.DECISION_BOX,
        image: DecisionBox,
      },
      {
        type: FormFieldTypesNames.CHECK_BOX,
        image: CheckBox,
      },
      {
        type: FormFieldTypesNames.RATING,
        image: Rating,
      },
      {
        type: FormFieldTypesNames.LINEAR_SCALING,
        image: Slider,
      },
    ],
  },
  {
    type: "SecondLayerField",
    fields: [
      {
        type: FormSecondLayerFieldListTypes.NAME,
        image: Name,
      },
      {
        type: FormSecondLayerFieldListTypes.ADDRESS,
        image: Address,
      },
      {
        type: FormSecondLayerFieldListTypes.PHONE,
        image: Phone,
      },
      {
        type: FormSecondLayerFieldListTypes.EMAIL,
        image: Mail,
      },
      {
        type: FormFieldTypesNames.DATE_INPUT,
        image: Dates,
      },
      {
        type: FormFieldTypesNames.TIME_PICKER,
        image: Time,
      },
      {
        type: FormFieldTypesNames.DATE_TIME_PICKER,
        image: Datetime,
      },
      {
        type: FormFieldTypesNames.CURRENCY,
        image: Currency,
      },
      // {
      //   type: FormFieldTypesNames.DESCRIPTION,
      //   image: Description,
      // },
      {
        type: FormFieldTypesNames.CALCULATIVE,
        image: Calculation,
      },
      {
        type: FormFieldTypesNames.NUMBER_INPUT,
        image: Number,
      },
      {
        type: FormThirdLayerFieldListTypes.PAYMENT,
        image: Payment,
      },
      {
        type: FormThirdLayerFieldListTypes.GEOLOCATION,
        image: geoLocationGroup,
      },
      {
        type: FormFieldTypesNames.BLANK_BOX,
        image: blankbox,
      },
      {
        type: FormFieldTypesNames.DATA_GRID,
        image: dataGrid,
      },

      {
        type: FormFieldTypesNames.SIGNATURE_BOX,
        image: SignatureLogo,
      },

      {
        type: FormFieldTypesNames.DOUBLE_PANEL,
        image: DoublePanel,
      },

      {
        type: FormFieldTypesNames.LINKED_DROPDOWN,
        image: linkedDropdown,
      },
    ],
  },
  // {
  //   type: "ThirdLayerField",
  //   fields: [
  //     {
  //       type: FormThirdLayerFieldListTypes.WEBSITE,
  //       image: Website,
  //     },
  //     {
  //       type: FormThirdLayerFieldListTypes.CALCULATIVE,
  //       image: Calculation,
  //     },
  //     {
  //       type: FormThirdLayerFieldListTypes.SECTION,
  //       image: Section,
  //     },
  //     {
  //       type: FormThirdLayerFieldListTypes.PAGE_BREAK,
  //       image: PageBreak,
  //     },
  //     {
  //       type: FormFieldTypesNames.FILE_UPLOAD,
  //       image: Fileupload,
  //     },
  //     {
  //       type: FormThirdLayerFieldListTypes.PAYMENT,
  //       image: Payment,
  //     },
  //   ],
  // },
];

export enum FormFieldsCategory {
  DEFAULT_FIELD = "DEFAULT_FIELD",
  PRE_DEFINED_FIELD = "PRE_DEFINED_FIELD",
  DISABLED_FIELD = "DISABLED_FIELD",
}

export const availableFieldsDetails = [
  // for now only available fields kept for test to be removed later
  {
    type: FormFieldsCategory.DEFAULT_FIELD,
    fields: [
      {
        type: FormFieldTypes.TEXT_INPUT,
        image: Singleline,
      },
      {
        type: FormFieldTypes.TEXT_AREA,
        image: Multiline,
      },
      {
        type: FormFieldTypes.DATE_INPUT,
        image: Dates,
      },
      {
        type: FormFieldTypes.TIME_PICKER,
        image: Time,
      },
      {
        type: FormFieldTypes.DATE_TIME_PICKER,
        image: Datetime,
      },
      {
        type: FormFieldTypes.CURRENCY,
        image: Currency,
      },
      {
        type: FormFieldTypes.DROPDOWN,
        image: Dropdown,
      },
      {
        type: FormFieldTypes.MULTIPLE_CHOICES,
        image: MultiChoice,
      },
      {
        type: FormFieldTypes.CHECK_BOX,
        image: CheckBox,
      },
      {
        type: FormFieldTypes.RATING,
        image: Rating,
      },
      {
        type: FormFieldTypes.LINEAR_SCALING,
        image: Slider,
      },
      {
        type: FormFieldTypes.FILE_UPLOAD,
        image: Fileupload,
      },
      {
        type: FormFieldTypes.DESCRIPTION,
        image: DescriptionField,
      },
      {
        type: FormFieldTypes.CALCULATIVE,
        image: Calculation,
      },
      {
        type: FormFieldTypes.NUMBER_INPUT,
        image: Number,
      },
      {
        type: FormFieldTypes.PAYMENT,
        image: Payment,
      },
      {
        type: FormFieldTypes.LOOKUP,
        image: lookupIcon,
      },
      {
        type: FormFieldTypes.GEOLOCATION,
        image: geoLocationGroup,
      },
      {
        type: FormFieldTypes.BLANK_BOX,
        image: blankbox,
      },
      {
        type: FormFieldTypes.DATA_GRID,
        image: dataGrid,
      },
      {
        type: FormFieldTypes.SEQUENCE,
        image: sequence,
      },
      {
        type: FormFieldTypes.PIN_CODE,
        image: pincode,
      },
      {
        type: FormFieldTypes.FORM_LINK,
        image: linkForm,
      },
      {
        type: FormFieldTypes.YEAR_SELECTOR,
        image: linkForm,
      },
      {
        type: FormFieldTypes.TIME_SLOT,
        image: linkForm,
      },
      {
        type: FormFieldTypes.BUTTON,
        image: button,
      },
      {
        type: FormFieldTypes.SIGNATURE_BOX,
        image: SignatureLogo,
      },
      {
        type: FormFieldTypes.DOUBLE_PANEL,
        image: DoublePanel,
      },
      {
        type: FormFieldTypes.BANNER,
        image: Banner,
      },
      {
        type: FormFieldTypes.LINKED_DROPDOWN,
        image: linkedDropdown,
      },
      {
        type: FormFieldTypes.CAPTCHA,
        image: recaptcha,
      },
    ],
  },
  {
    type: FormFieldsCategory.PRE_DEFINED_FIELD,
    fields: [
      {
        type: PreDefinedFormFieldTypes.SECTION,
        image: sectionIcon,
      },
      {
        type: PreDefinedFormFieldTypes.NAME,
        image: Name,
      },
      {
        type: PreDefinedFormFieldTypes.ADDRESS,
        image: Address,
      },
      {
        type: PreDefinedFormFieldTypes.MOBILE,
        image: Phone,
      },
      {
        type: PreDefinedFormFieldTypes.EMAIL,
        image: Mail,
      },
      {
        type: PreDefinedFormFieldTypes.URL,
        image: Website,
      },
    ],
  },

  // {
  //   type: FormFieldsCategory.DISABLED_FIELD,
  //   fields: [
  //     {
  //       type: FormFieldTypes.DECIMAL,
  //       image: Decimal,
  //     },
  //     {
  //       type: FormFieldTypes.DECISION_BOX,
  //       image: DecisionBox,
  //     },
  //     {
  //       type: FormFieldTypes.CALCULATIVE,
  //       image: Calculation,
  //     },
  //     {
  //       type: FormFieldTypes.PAGE_BREAK,
  //       image: PageBreak,
  //     },
  //     {
  //       type: FormFieldTypes.PAYMENT,
  //       image: Payment,
  //     },
  //   ],
  // },
];

export const StartLinearScaleOptions = {
  0: "0",
  1: "1",
};

export const EndLinearScaleOptions = {
  2: "2",
  3: "3",
  4: "4",
  5: "5",
  6: "6",
  7: "7",
  8: "8",
  // 9: "9",
  // 10: "10",
};

export const LinearScaleOptions = {
  0: "0",
  1: "1",
  2: "2",
  3: "3",
  4: "4",
  5: "5",
  6: "6",
  7: "7",
  8: "8",
  // 9: "9",
  // 10: "10",
};

export const MaxNumFiles = {
  1: "1",
  3: "3",
  10: "10",
};

export const MaxFileSize = {
  1: "1 Mb",
  10: "10 Mb",
  100: "100 Mb",
  1000: "1 Gb",
  10000: "10 Gb",
};

export const widthOptions = {
  1: "100 %",
  0.95: "95 %",
  0.85: "85 %",
  0.75: "75 %",
  0.7: "70 %",
  0.65: "65 %",
  0.5: "50 %",
  0.45: "45 %",
  0.4: "40 %",
  0.3: "30 %",
  0.2: "20 %",
  0.1: "10 %",
  // 0.75: "75 %",
  // 0.5: "50 %",
  // 0.33: "33 %",
  // 0.25: "25 %",
};
export const linearScaleWidthOptions = {
  1: "100 %",
  0.75: "75 %",
};

export const gridSize = {
  1: "1",
  2: "2",
  3: "3",
  4: "4",
  5: "5",
  6: "6",
  7: "7",
  8: "8",
  9: "9",
  10: "10",
  11: "11",
  12: "12",
};

export const alignment = {
  "flex-start": "Left",
  center: "Center",
  "flex-end": "Right",
  "space-between": "Space Between",
};

export enum justify {
  "flex-start" = justifyContentEnum.flexStart,
  "center" = justifyContentEnum.center,
  "flex-end" = justifyContentEnum.flexEnd,
  "space-between" = justifyContentEnum.spaceBetween,
  "space-around" = justifyContentEnum.spaceAround,
  "space-evenly" = justifyContentEnum.spaceEvenly,
}

export const fieldPermissions = {
  VIEW: "VIEW",
  CREATE: "CREATE",
  EDIT: "EDIT",
  // EXPORT:'EXPORT',
  DELETE: "DELETE",
};

export const encriptTypes = {
  STAR: "Star Mark",
  DISPLAY: "Half Display",
  Eye: "Eye Button",
};

export const currencyTypes = {
  IND: "Indian Rupees",
  USA: "United States Dollars",
  CHN: "China Yuan",
  EUR: "Euro",
  GBP: "British Pound",
  JPY: "Japanese Yen",
  AUD: "Australian Dollar",
  CAD: "Canadian Dollar"

};

export const separatorTypes = {
  normal: "Normal",
  thousand: "Thousand",
  lakh: "Lakh",
  // wan: "Wan",
};
export const thousandSeparator = {
  normal: ",",
  thousand: ",",
  lakh: ",",
  wan: ",",
  dot: ".",
};
export const decimalSeparator = {
  normal: ".",
  thousand: ".",
  lakh: ".",
  wan: ".",
  dot: ",",
};
export const decimalScale = {
  1: "1 Decimals",
  2: "2 Decimals",
  3: "3 Decimals",
  4: "4 Decimals",
  5: "5 Decimals",
  6: "6 Decimals",
  7: "7 Decimals",
  8: "8 Decimals",
  9: "9 Decimals",
};
export enum currencyDisplayTypes {
  CODE = "Code",
  SYMBOL = "Symbol",
}

export enum currencySymbol {
  USA = "$",
  IND = "₹",
  CHN = "¥",
  EUR = "€",
  GBP = "£",
  JPY = "¥",
  AUD = "A$",
  CAD = "C$",
}

export enum currencyCode {
  USA = "USD",
  IND = "INR",
  CHN = "CNY",
}

export enum sortTypes {
  none = "none",
  asc = "asc",
  desc = "desc",
}

export enum sortTypesNames {
  none = "None",
  asc = "Ascending",
  desc = "Descending",
}

export interface IFieldFocusStyle {
  isEditingField: boolean;
  isDisabled: boolean;
}
export type FieldProps =
  | IFormMultipleChoiceProps
  | IFormTextAreaFieldProps
  | IFormTextInputFieldProps
  | IPincodeFieldProps
  | IFormNumberInputFieldProps
  | IFormTimePickerFieldProps
  | IFormDateInputProps
  | IFormLinearScaleProps
  | IFormFileUploadFieldProps
  | IFormRatingFieldProps
  | ICheckBoxFieldProps
  | IFormGeolocationFieldProps
  | IFormCalculativeInputFieldProps
  | IFormDescriptionFieldProps
  | IEmptyFieldProps
  | IFormPaymentInputFieldProps
  | IFormCurrencyFieldProps
  | IFormLookUpFieldProps
  | IFormSequenceFieldProps
  | IFormTimeSlotProps
  | IFormButtonFieldProps
  | IFormBannerFieldProps
  | IFormSignatureFieldProps
  | IFormDoublePanelFieldProps
  | IFormLinkedDropdownField
  | IFormCaptchaFieldProps;
